import { EventEmitter } from '@angular/core';
import { IValue } from "./ivalue";
import { ControlType } from "../controltype";

export class DateRangeValue implements IValue {
    clear$ = new EventEmitter();


    startTime: string;
    endTime: string;

    constructor(value: { startTime: string, endTime: string } = { startTime: '', endTime: '' }) {
        this.startTime = value.startTime;
        this.endTime = value.endTime;
    }
    isEmpty(): boolean {
        return !this.startTime || !this.endTime;
    }

    setOriginalValue(value: { formatted: string, delimiter: string }): void {
        if (value.formatted) {
            this.startTime = value.formatted.split(value.delimiter)[0];
            this.endTime = value.formatted.split(value.delimiter)[1];
        } else {
            this.clearValue();
        }
    }
    getOriginalValue() {
        return `${this.startTime}~${this.endTime}`;
    }
    getControlType(): ControlType {
        return ControlType.DateRange;
    }
    clearValue(): void {
        this.startTime = undefined;
        this.endTime = undefined;

        this.clear$.emit();
    }
}